import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Slider } from "antd";
import { useI18n, useUpsell } from "../../../../../contexts";
const FormContentBlockerFieldVisualBlur = ()=>{
    const { __ } = useI18n();
    const { isPro } = useUpsell();
    return isPro && /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.isVisual !== nextValues.isVisual || prevValues.visualType !== nextValues.visualType,
        children: (param)=>{
            let { getFieldValue } = param;
            const isVisual = getFieldValue("isVisual");
            const visualType = getFieldValue("visualType");
            return !!isVisual && visualType !== "default" && /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Blur image"),
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "visualBlur",
                        noStyle: true,
                        children: /*#__PURE__*/ _jsx(Slider, {
                            min: 0,
                            max: 20,
                            marks: {
                                0: __("Disabled"),
                                5: "5%",
                                10: "10%",
                                15: "15%",
                                20: "20%"
                            },
                            tooltip: {
                                open: false
                            },
                            style: {
                                marginLeft: 40
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: __("You can apply an additional blur to the background image. This can be useful e.g. for blocked contact forms to show it only schematically.")
                    })
                ]
            });
        }
    });
};
export { FormContentBlockerFieldVisualBlur };
